import { render, staticRenderFns } from "./Dependencies.vue?vue&type=template&id=162969fe&scoped=true&"
import script from "./Dependencies.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dependencies.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162969fe",
  null
  
)

export default component.exports